// Extra
/*!
 * Extra scripts
 */

$(document).ready(function () {
  // Key Press Handling for Accessibility
  $('[role="button"]').on("keypress", function (e) {
    if (e.which === 13 || e.which === 32) {
      // Enter key or Space bar
      $(this).click();
    }
  });

  // Bootstrap, add .modal-open to body if any modals are open
  $("body").on("hidden.bs.modal", function () {
    if ($(".modal.show").length > 0) {
      $("body").addClass("modal-open");
    }
  });

  // End
});
